(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sirene-cart-upsell"] && !Shopify.designMode) return;
  try {
    async function sireneSubmitCartOffer(panel, button, items) {
  if (panel.dataset.submitting === 'true' || !items.length) return;
  panel.dataset.submitting = 'true';
  panel.setAttribute('aria-busy', 'true');
  const controls = panel.querySelectorAll('button, select');
  const labelNodes = Array.from(button.childNodes);
  const error = panel.querySelector('[data-extra-error]');
  const cartUrl = panel.dataset.cartUrl || button.dataset.cartUrl;
  const addUrl = panel.dataset.addUrl || button.dataset.addUrl;
  const failureText = panel.dataset.error || button.dataset.error;
  error.textContent = '';
  controls.forEach((control) => { control.disabled = true; });
  button.textContent = panel.dataset.busy || button.dataset.busy;
  let added = false;
  let attemptedAdd = false;
  try {
    if (panel.hasAttribute('data-sc-upgrade') || panel.hasAttribute('data-sc-extra')) {
      const currentResponse = await fetch(`${cartUrl}.js`, { headers: { Accept: 'application/json' }, cache: 'no-store' });
      if (!currentResponse.ok) throw new Error(failureText);
      const current = await currentResponse.json();
      const eligible = JSON.parse(panel.dataset.productIds).map(String);
      const count = current.items.filter((item) => eligible.includes(String(item.product_id))).reduce((sum, item) => sum + item.quantity, 0);
      const expected = Number(panel.dataset.currentCount);
      if ((expected >= 5 && count < 5) || (expected < 5 && count !== expected)) {
        location.assign(cartUrl);
        return;
      }
    }
    attemptedAdd = true;
    const response = await fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items, sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: location.pathname })
    });
    const state = await response.json();
    if (!response.ok || state.status) {
      const refresh = await fetch(`${location.pathname}?sections=cart-drawer,cart-icon-bubble`, { cache: 'no-store' });
      const sections = await refresh.json();
      const drawer = panel.closest('cart-drawer');
      if (!refresh.ok || !drawer || !sections['cart-drawer'] || !sections['cart-icon-bubble']) {
        location.assign(cartUrl);
        return;
      }
      drawer.renderContents({ sections });
      const cartError = document.getElementById('CartDrawer-CartErrors');
      if (cartError) cartError.textContent = state.description || failureText;
      return;
    }
    added = true;
    const drawer = panel.closest('cart-drawer');
    if (!drawer || !state.sections || !state.sections['cart-drawer'] || !state.sections['cart-icon-bubble']) {
      location.assign(cartUrl);
      return;
    }
    drawer.setActiveElement(document.getElementById('cart-icon-bubble'));
    drawer.renderContents(state);
  } catch (failure) {
    if (added || attemptedAdd) location.assign(cartUrl);
    else error.textContent = failure.message || failureText;
  } finally {
    controls.forEach((control) => { control.disabled = false; });
    panel.dataset.submitting = 'false';
    panel.removeAttribute('aria-busy');
    button.replaceChildren(...labelNodes);
  }
}


document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-sirene-extra-add]');
  if (!button || button.disabled) return;
  await sireneSubmitCartOffer(button.closest('.sirene-extra'), button, [{ id: button.dataset.variantId, quantity: 1 }]);
});
  } catch(e) { console.error(e); }
})();

})();
